module.exports = __webpack_public_path__ + "static/media/AGM.8ef2a5dd.svg";